import { mergeObjectTypes } from '../cacheHelpers';

const RichDateTime = {
  merge: mergeObjectTypes
};

export default RichDateTime;
